import { AppImages } from 'components';
import * as AppPics from 'assets/images';
import React from 'react';

function SearchTextField(props) {
  const { handleSearch, size, inputProps = {} } = props;
  const { classNames = '', ...ipProps } = inputProps;

  const [search, setSearch] = React.useState('');

  if (size === 'small') {
    return (
      <>
        <div className="mainHeader__search mainHeader__searchInput_medium">
          <input
            type="text"
            className={`mainHeader__searchInput ${classNames}`}
            placeholder="Type to search..."
            {...ipProps}
            value={search}
            onChange={(event) => setSearch(event.target.value)}
          />
          <span
            className="mainHeader__searchBtn"
            onClick={() => {
              handleSearch(search);
            }}
          >
            <AppImages src={AppPics.TopMenuSearchSvg} alt="Click to search" />
          </span>
        </div>
      </>
    );
  }

  return (
    <div className="mainHeader">
      <div className="mainHeader__search">
        <input
          type="text"
          className={`mainHeader__searchInput ${classNames}`}
          placeholder="Type to search..."
          {...props}
        />
        <span className="mainHeader__searchBtn">
          <AppImages src={AppPics.TopMenuSearchSvg} alt="Click to search" />
        </span>
      </div>
    </div>
  );
}

export default SearchTextField;
